// Thin client for the /api/stats endpoints. Errors (non-2xx, 401) are already
// surfaced by the global fetch interceptor in _app.js; callers await the happy
// path and catch to stop their own flow.

async function jsonFetch(url, options) {
	const res = await fetch(url, options);
	if (!res.ok) {
		const err = new Error(`Request failed: ${res.status}`);
		err.status = res.status;
		throw err;
	}
	return res.status === 204 ? null : res.json();
}

/** Aggregated operational metrics for the home dashboard. `date` = YYYY-MM-DD. */
export function getDashboard(date) {
	const qs = date ? `?date=${encodeURIComponent(date)}` : "";
	return jsonFetch(`/api/stats/dashboard${qs}`);
}

/**
 * Download the dashboard metrics for `date` (or today) as a CSV file. Fetches
 * as a blob so the httpOnly session cookie authenticates the request, then
 * triggers a browser download from the Content-Disposition filename.
 */
export async function downloadDashboardCsv(date) {
	const qs = date ? `?date=${encodeURIComponent(date)}` : "";
	const res = await fetch(`/api/stats/dashboard.csv${qs}`);
	if (!res.ok) {
		const err = new Error(`Request failed: ${res.status}`);
		err.status = res.status;
		throw err;
	}
	const blob = await res.blob();
	const disposition = res.headers.get("Content-Disposition") || "";
	const match = /filename="?([^"]+)"?/.exec(disposition);
	const filename = match ? match[1] : `panel-${date || "hoy"}.csv`;
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	a.remove();
	URL.revokeObjectURL(url);
}
